import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import { DeviceData } from "../models/DeviceData";
import { Message } from "../models/ProtectiveFunctionWrapper";
import { MasterPoolMismatchItem } from "../models/MasterPoolMismatchItem";

type DeviceType = "Device" | "SSS" | "LSS" | "ManualInputDevice";

interface Props {
    x: string;
    y: string;
    boxSize: string;
    imgWidth: string;
    imgHeight: string;
    device?: DeviceData;
    type: DeviceType;
    handleDeviceClicked: (device: DeviceData, type: string) => void;
    handleDeviceRightClicked: (e: React.MouseEvent, device: DeviceData) => void;
    errorsAndWarnings?: Message[];
    masterPoolMismatchItems?: MasterPoolMismatchItem[];
}

const generateImageSrcLocation = (type: DeviceType, pt: PT_ProtectiveFunction) => {
    if (pt.source.trim() !== "SIL") {
        return `/HTMLImages/${type}/Cus/${pt.deviceId.trim()}.bmp`;
    } else {
        return `/HTMLImages/${type}/${pt.deviceId.trim()}.bmp`;
    }
}

const toggleStyle: React.CSSProperties = {
    display: "inline-block",
    marginLeft: 15
};

const Device = (props: Props) => {
    if (props.device == null) {
        return null;
    }

    const type = props.type;

    var hasWarning = false;
    var hasError = false;
    var isMismatchMasterPool = false;
    var errorsAndWarningsText = "";
    if (props.errorsAndWarnings) {
        hasWarning = props.errorsAndWarnings.some(x => x.messageType === 'warning');
        hasError = props.errorsAndWarnings.some(x => x.messageType === 'error');
        errorsAndWarningsText = props.errorsAndWarnings.map(x => x.formatMessageById(props.device.ptProtectiveFunction.protectiveFunctionID)).join('\n');
    }
    if (props.masterPoolMismatchItems) {
        isMismatchMasterPool = props.masterPoolMismatchItems.some(x => x.protectiveFunctionId == props.device.ptProtectiveFunction.protectiveFunctionID);
    }

    return (
      <div
        id={props.device.ptProtectiveFunction && props.device.ptProtectiveFunction.devicePosition != null ? props.device.ptProtectiveFunction.devicePosition.trim() : null}
            title={errorsAndWarningsText}
            className={`${props.type} ${hasWarning ? "warning-message" : ""} ${hasError ? "error-message" : ""}`.trim()} style={{ zIndex: 1000, left: props.x, top: props.y, width: props.boxSize, height: props.boxSize, display: "block", position: "absolute", pointerEvents: "all" }}
            onClick={() => props.handleDeviceClicked(props.device, type)}
            onContextMenu={(e: React.MouseEvent) => props.handleDeviceRightClicked(e, props.device)}>
            {props.device.ptProtectiveFunction
                ? <img src={generateImageSrcLocation(props.type, props.device.ptProtectiveFunction)} style={{width: props.imgWidth, height: props.imgHeight}} />
        : null
        }
        {isMismatchMasterPool ? <span title="Device does not match the 'master pool' device sheets." className="fa fa-info-circle" style={{ position: "absolute", top: "0",  left: "0", color: "#f90000", fontSize: "12px"}}></span> : null}
    </div>
  );
};

export default Device;